import React, { useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Paper, Typography, TextField } from "@material-ui/core";

// Contexts
import OrderContext from "../../../../../../context/orders/v1/OrdersContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
  },
  rowBottom: {
    marginBottom: "0.5rem",
  },
  title: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    marginTop: "0.3rem",
  },
}));

const RefundReasons = () => {
  const classes = useStyles();
  const { modalValues, setValues } = useContext(OrderContext);

  const handleChange = (e) => {
    if (e.target.id === "reasons") {
      setValues({ ...modalValues, [e.target.id]: e.target.value });
    }
  };

  return (
    <Grid container direction="column" justifyContent="flex-start">
      <Paper className={classes.paper}>
        <Grid
          item
          container
          xs={12}
          direction="column"
          alignItems="flex-start"
          justifyContent="flex-start"
        >
          <Grid item container xs={12} className={classes.rowBottom}>
            <Typography variant="body1" className={classes.title}>
              Reasons for refund{" "}
            </Typography>{" "}
          </Grid>
          <Grid item container xs={12}>
            <TextField
              type="text"
              variant="outlined"
              fullWidth
              size="small"
              margin="dense"
              id="reasons"
              value={modalValues.reasons ? modalValues.reasons : ""}
              onChange={handleChange}
              inputProps={{
                maxLength: 120,
              }}
            />{" "}
          </Grid>
          <Grid item>
            <Typography variant="body2">
              Only you and other staff can see this reason.{" "}
            </Typography>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Paper>{" "}
    </Grid>
  );
};

export default RefundReasons;
